<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      top="2vh"
      width="1200px"
      :title="
        type === 'add'
          ? $l('title_add_booking') || '新增订舱记录'
          : $l('title_edit_booking') || '编辑订舱记录'
      "
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        :shipmentCode="shipmentCode"
        :shipmentBookingCode="shipmentBookingCode"
        :listContainer="listContainer"
        @close="close"
        @reload="$emit('reload')"
      />

      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{
            type === 'add'
              ? $l('btn_confirm_create') || '确认创建'
              : $l('btn_confirm_save') || '确认保存'
          }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'

export default {
  components: { Main },
  props: {
    type: { type: String, default: 'add' },
    visible: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
    listContainer: { type: Array, default: () => [] },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
